import { call, cancelled, put, select, takeEvery } from 'redux-saga/effects'
import apiClient from 'services/axios'
import { updateEntities } from 'redux/entities'
import actions from './actions'
import getPage from './selectors'

function* fetchPagination(url, normalize, loadMore = false) {
  const { fetching, next_page_url } = yield select(getPage(url))
  yield put({ type: actions.FETCHING, url })
  if (fetching) return false
  if (loadMore && !next_page_url) return false
  try {
    const { data } = yield call(apiClient.get, loadMore ? next_page_url : url)
    const { entities, result } = yield call(normalize, data)
    yield put(updateEntities(entities))
    yield put({
      type: actions.FULFILLED,
      payload: {
        result,
        ...data,
      },
      url,
    })
  } catch (err) {
    yield put({ type: actions.REJECTED, url })
  } finally {
    if (yield cancelled()) {
      console.log('cancelled')
    }
  }
  return false
}

export default (action, norm) => {
  const [FETCH, FETCH_MORE] = action

  function* fetchList({ url }) {
    yield call(fetchPagination, url, norm)
  }

  function* fetchListNext({ url }) {
    yield call(fetchPagination, url, norm, true)
  }

  return [takeEvery(FETCH, fetchList), takeEvery(FETCH_MORE, fetchListNext)]
}
